module.exports = __webpack_public_path__ + "img/SI2211254.5d6d44d4.png";